var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-count-container"},[_c('div',{staticClass:"image-count-indicator"},[_vm._v(" "+_vm._s(_vm.activeIndex + 1)+" "),_c('span',{staticStyle:{"color":"rgba(240, 240, 240, 0.5)"}},[_vm._v("· "+_vm._s(_vm.imageCount)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }